"use strict";var e;exports.ExpendableType=void 0,(e=exports.ExpendableType||(exports.ExpendableType={})).SINGLE="SINGLE",e.MULTIPLE="MULTIPLE";
//# sourceMappingURL=types.js.map
